import { Directive, Input, HostListener, ElementRef } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'img[default]',
    standalone: false,
})
export class DefaultImageDirective {
    @Input() default?: string;

    constructor(private element: ElementRef<HTMLImageElement>) {}

    @HostListener('error')
    updateUrl() {
        if (this.default) {
            this.element.nativeElement.src = this.default;
        }
    }
}
